// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/climbing-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/climbing-technique/climbing-technique.js';

mount([g0]);
